import { makeStyles } from '@material-ui/styles'
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
    contentDiv: {
      width: "100%"
    },
    icon: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        '& .MuiSvgIcon-root': {
            marginRight: 5,
        },
    },
    stepCompleted: {
        root : {
            color: 'green'
        }
    },
    layoutContainer: {
      height: 200,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: theme.spacing(2),
      border: "1px dashed",
      borderColor: theme.palette.primary.main,
      position: "relative"
    },
    layoutText: {
      color: tinycolor(theme.palette.background.light)
        .darken()
        .toHexString()
    },
    layoutButtonsRow: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    },
    layoutButton: {
      backgroundColor: theme.palette.background.light,
      width: 125,
      height: 50,
      outline: "none",
      border: "none"
    },
    layoutButtonActive: {
      backgroundColor: tinycolor(theme.palette.background.light)
        .darken()
        .toHexString()
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginTop: theme.spacing(2)
    },
    notificationCallButton: {
      color: "white",
      marginBottom: theme.spacing(1),
      textTransform: "none"
    },
    customPropertiesContainer: {
      //border: "1px solid #C4C4C4",
      //borderRadius: "5px",
      padding: "8px",
      //boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Add shadow effect
      //marginBottom: "16px",
    },
    customProperty: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      '& > .property-name': {
        minWidth: '300px'
      },
      '& > .customPropertiesTypeSelect': {
        minWidth: '150px'
      },
      alignItems: 'center'
    },
    customPropertyInput: {
      marginRight: "8px",
      width: "200px",
    },
    customPropertySelect: {
      marginRight: "5px",
    },
    customPropertyButton: {
      flex: '0 0 auto', // Align the delete button to the right
      marginBottom: 20
    },
}))
